import { FC } from 'react';

import { StyledBox } from './Separator.style';
import { SeparatorProps } from './Separator.types';

const Separator: FC<SeparatorProps> = ({ css }) => {
  return <StyledBox data-testid="separator" css={{ ...css }} />;
};

export default Separator;
